// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"531dfc5d","496":"15c9d26c"}[chunkId] + ".chunk.js";
};